'use client';

import { Eye, EyeOff } from 'lucide-react';
import formStyles from './form.module.css';

interface VisibilityToggleProps {
	/** Whether the value is currently public (shown on the profile). */
	isPublic: boolean;
	/** Flip the public/private state. */
	onToggle: () => void;
	disabled?: boolean;
	/** Accessible label; defaults to a generic profile-visibility phrasing. */
	ariaLabel?: string;
}

/**
 * Public/private visibility pill used across the registration wizard and the
 * CV edit modals. Shows an eye + "Público" when public, a crossed eye +
 * "Oculto" when private.
 */
export function VisibilityToggle({ isPublic, onToggle, disabled, ariaLabel }: VisibilityToggleProps) {
	return (
		<button
			type="button"
			className={`${formStyles.visibilityActionBtn} ${isPublic ? formStyles.visibilityPublicBtn : formStyles.visibilityPrivateBtn}`}
			onClick={onToggle}
			disabled={disabled}
			aria-label={ariaLabel ?? (isPublic ? 'Ocultar del perfil' : 'Mostrar en el perfil')}
		>
			{isPublic ? <Eye size={14} /> : <EyeOff size={14} />}
			<span>{isPublic ? 'Público' : 'Oculto'}</span>
		</button>
	);
}
